export var LIVE_SESSIONS_TRANSLATION_KEY = 'compass-live-sessions';